export default __webpack_public_path__ + "static/media/ermine_landscape.4083c91f.png";